<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Batch Jobs</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="24">
          <a-col :span="8">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search" @input="onSearch"></a-input>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable 
            :pagination="pagin"
            :columns="BatchJobListColumns"
            :dataSource="filterData"
            :tableSize="tableSize">
            <template slot="batchJobId" slot-scope="{ record }">
              <div>
                <template v-if="record.jobTypeCode === 'CR'">
                  <router-link class="nav-link-detail d-inline-block" :to="'./detail-crawl/' + record.id">
                    {{ record.id }}
                  </router-link>
                </template>
                <template v-else>
                  <router-link class="nav-link-detail d-inline-block" :to="'./detail/' + record.id">
                    {{ record.id }}
                  </router-link>
                </template>
              </div>
            </template>
            <template slot="started_at" slot-scope="{ record }">
              <div>
                <p class="time-text">{{ record.started_at | dateString }}</p>
                <p class="time-text">{{ record.started_at | timeString }}</p>
              </div>
            </template>
            <template slot="status" slot-scope="{ record }">
              <a-tag :color="tagStatusColor(record.status)">
                {{ record.status }}
              </a-tag>
            </template>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item>
                    <a-icon type="eye" />
                    <template v-if="record.jobTypeCode === 'CR'">
                      <router-link class="nav-link-detail d-inline-block" :to="'./detail-crawl/' + record.id">View Detail {{ record.id }}</router-link>
                    </template>
                    <template v-else>
                      <router-link class="nav-link-detail d-inline-block" :to="'./detail/' + record.id">View Detail {{ record.id }}</router-link>
                    </template>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { BatchJobStatusColorTag, BatchJobStatus } from '../consts/BatchJob.consts';
  import BatchJobService from '../services/BatchJob.service';
  import { BatchJobListColumns } from '../columnsTable/BatchJobColumns';

  export default {
    name: 'BatchJobList',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        BatchJobStatus,
        BatchJobStatusColorTag,
        BatchJobListColumns,
        $_data: [],
        filterData: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    computed: {
      tagStatusColor() {
        return (status) => {
          switch (status) {
            case BatchJobStatus.Completed:
            case BatchJobStatus.Finished: {
              return BatchJobStatusColorTag.Finished;
            }
            case BatchJobStatus.Cancelled: {
              return BatchJobStatusColorTag.Cancelled;
            }
            default: {
              return BatchJobStatusColorTag.NotFinished;
            }
          }
        };
      }
    },
    mounted() {
      this.fetchList();
    },
    beforeDestroy() {},
    methods: {
      onSearch: debounce(function (inputChangeEvent) {
        const inputSearchValue = inputChangeEvent.target.value;
        this.filterParams.search = inputSearchValue && String(inputSearchValue).trim().toLowerCase();
        this.filter();
      }, 800),
      filter() {
        const filterResult = this.$_data.filter((item) => {
          const filterById = (item.id || '').trim().toLowerCase().includes(this.filterParams.search);
          const filterByJobType = (item.job_type || '').trim().toLowerCase().includes(this.filterParams.search);
          const filterByStatus = (item.status || '').trim().toLowerCase().includes(this.filterParams.search);
          return filterById || filterByJobType || filterByStatus;
        });
        this.filterData = filterResult;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: filterResult.length
        };
      },
      async fetchList() {
        try {
          const batchJobListData = await BatchJobService.fetchList();
          this.$_data = (batchJobListData || []).map((item, index) => {
            const jobTypeCode = /^cr/i.test((item.job_type || '')) ? 'CR' : item.job_type;
            return {
              ...item,
              jobTypeCode,
              index: index + 1,
            };
          });
          this.filter();
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
    white-space: nowrap;
  }
  .nav-link-detail {
    &:hover {
      text-decoration: underline;
    }
  }
</style>
